import gsap from 'gsap';
import horizontalLoop from './horizontalLoop';

export default class HorizontalLoopHandler {
    constructor() {
        this.instances = [];

        this.create();
    }

    update() {
        // this.instances.forEach((instance) => {
        //     instance.destroy();
        // });
        this.instances = [];
        this.create();
    }

    create() {
        this.instances = gsap.utils.toArray('[data-w-hloop]');

        this.instances.forEach((wrapper) => {
            const boxes = gsap.utils.toArray('[data-w-hloop-item]');
            const parent = wrapper.closest('[data-w-hloop-container]');

            let timescale;
            let activeElement;
            let modalOpen = false;

            const loop = horizontalLoop(boxes, {
                repeat: -1,
                paused: false,
                draggable: true,
                speed: 0.5,
                center: true,
                reversed: true,
                onChange: (element, index) => {
                    activeElement &&
                        activeElement.classList.remove('w-is-active');
                    element.classList.add('w-is-active');
                    activeElement = element;
                },
            });

            boxes.forEach((box, i) => {
                box.addEventListener('click', (e) => {
                    e.preventDefault();

                    if (!modalOpen) {
                        timescale = 0 > loop.timeScale();

                        loop.toIndex(i, {
                            duration: 0.5,
                            ease: 'power1.inOut',
                        });
                        loop.draggable.disable();
                        // wrapper.classList.add('w-is-paused');
                        modalOpen = true;

                        const connectedSlide = parent.querySelector(
                            box.getAttribute('data-w-hloop-target')
                        );
                        connectedSlide.classList.add('w-is-active');

                        parent.classList.add('w-has-active');
                        document.documentElement.classList.add(
                            'w-has-dialog-open'
                        );
                    } else {
                        const connectedSlide = parent.querySelector(
                            '[data-w-hloop-modal-item].w-is-active'
                        );
                        connectedSlide.classList.remove('w-is-active');

                        parent.classList.remove('w-has-active');
                        document.documentElement.classList.remove(
                            'w-has-dialog-open'
                        );

                        modalOpen = false;

                        loop.draggable.enable();
                    }
                });
            });

            parent
                .querySelector('[data-w-hloop-modal-close]')
                .addEventListener('click', (e) => {
                    e.preventDefault();

                    if (modalOpen) {
                        const connectedSlide = parent.querySelector(
                            '[data-w-hloop-modal-item].w-is-active'
                        );
                        connectedSlide.classList.remove('w-is-active');

                        parent.classList.remove('w-has-active');
                        document.documentElement.classList.remove(
                            'w-has-dialog-open'
                        );

                        modalOpen = false;

                        loop.draggable.enable();

                        setTimeout(() => {
                            if (!modalOpen) {
                                loop.reverse();
                                gsap.to(loop, {
                                    timeScale: timescale ? -1 : 1,
                                    duration: 1,
                                    overwrite: true,
                                });
                                // wrapper.classList.remove('w-is-paused');
                            }
                        }, 1000);
                    }
                });

            if (matchMedia('(hover: hover)').matches) {
                wrapper.addEventListener('mouseenter', () => {
                    if (!modalOpen) {
                        timescale = 0 > loop.timeScale();
                        gsap.to(loop, {
                            timeScale: 0,
                            duration: 1,
                            overwrite: true,
                        });
                        // wrapper.classList.add('w-is-paused');
                    }
                });
                wrapper.addEventListener('mouseleave', () => {
                    if (!modalOpen) {
                        loop.reverse();
                        gsap.to(loop, {
                            timeScale: timescale ? -1 : 1,
                            duration: 1,
                            overwrite: true,
                        });
                        // wrapper.classList.remove('w-is-paused');
                    }
                });
            }
        });
    }
}
